export interface FileValidationOptions {
  acceptedMimeTypes: string[];
  maxSizeMB: number;
}

export interface FileValidationResult {
  typeError: boolean;
  sizeError: boolean;
  valid: boolean;
}

export const validateFile = (file: File, options: FileValidationOptions): FileValidationResult => {
  const { acceptedMimeTypes, maxSizeMB } = options;
  const maxBytes = maxSizeMB * 1024 * 1024;
  const ext = file.name.toLowerCase().split('.').pop() ?? '';
  const typeError = !acceptedMimeTypes.includes(file.type) && !acceptedMimeTypes.some(m => m.endsWith(ext));
  const sizeError = !typeError && file.size > maxBytes;
  return { typeError, sizeError, valid: !typeError && !sizeError };
};

export const read = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener('error', error => {
      reject(error);
    });

    reader.addEventListener('load', () => {
      resolve(String(reader.result));
    });

    reader.readAsDataURL(file);
  });
};
